<script setup lang="ts">
import LogoMark from '@/components/brand/LogoMark.vue'
</script>

<template>
  <div class="min-h-screen flex" style="background: var(--app-bg);">

    <!-- Left panel -->
    <div
      class="hidden lg:flex flex-col w-[420px] shrink-0 relative overflow-hidden p-10 justify-between"
      style="background: var(--sidebar-bg); border-right: 1px solid var(--sidebar-border);"
    >
      <!-- Glow orbs -->
      <div class="absolute -top-32 -left-32 w-80 h-80 rounded-full pointer-events-none" style="background: radial-gradient(circle, rgba(116,183,67,0.12) 0%, transparent 70%);" />
      <div class="absolute -bottom-24 -right-24 w-64 h-64 rounded-full pointer-events-none" style="background: radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%);" />

      <div class="flex items-center gap-3 relative z-10">
        <LogoMark class="w-9 h-9 rounded-md object-cover" />
        <div class="leading-none">
          <p class="text-sm font-semibold text-white">Skylark</p>
          <p class="text-2xs text-white/50 tracking-widest uppercase">Northstar</p>
        </div>
      </div>

      <div class="relative z-10">
        <p class="text-white text-2xl font-bold mb-3">Northstar</p>
        <p class="text-white/80 text-lg font-medium leading-snug mb-3">
          Project lifecycle &amp; financial management
        </p>
        <p class="text-sm leading-relaxed" style="color:var(--sidebar-text);">
          One place for engineering projects, procurement, warehousing and finance.
        </p>
      </div>

      <p class="text-2xs relative z-10" style="color:var(--sidebar-text-muted);">
        &copy; {{ new Date().getFullYear() }} Skylark. Internal use only.
      </p>
    </div>

    <!-- Right panel — form -->
    <div class="flex flex-1 items-center justify-center p-8">
      <div class="w-full max-w-sm">
        <div class="flex items-center gap-2.5 mb-8 lg:hidden">
          <LogoMark class="w-8 h-8 rounded object-cover" />
          <div class="leading-none">
            <span class="text-sm font-semibold" style="color:var(--ink-primary);">Skylark</span>
            <p class="text-2xs text-ink-disabled tracking-widest uppercase">Northstar</p>
          </div>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>
